import { OrderType } from '@travelwin/core';

import { request as authorizedRequests } from '../helpers/authorizedRequests';

const baseUri = 'ecommerce';

export const registerContact = (): Promise<OrderType> => {
  const options = {
    method: 'POST',
  };
  return authorizedRequests(`${baseUri}/users`, options);
};

export const updateUserName = () => {
  const options = {
    method: 'PATCH',
  };
  return authorizedRequests(`${baseUri}/users/account`, options);
};

export const changeMarketingConsent = (): Promise<OrderType> => {
  const options = {
    method: 'PATCH',
  };
  return authorizedRequests(`${baseUri}/users/marketing`, options);
};

export const deleteUser = () => {
  const options = {
    method: 'DELETE',
  };

  const path = 'ecommerce/users';

  return authorizedRequests(path, options);
};

export const invalidateUser = () => {
  const options = {
    method: 'DELETE',
  };

  const path = 'ecommerce/users/invalidate';

  return authorizedRequests(path, options);
};
